<div class="list-page-container">
  <div class="content-container" *ngIf="!loading; else isLoading">
    <div class="page-header-container">
      <app-page-header [title]="pageTitle"></app-page-header>
    </div>
    <div *ngIf="isSponsor">
      <div *ngIf="showPopUpPage">
        <app-acceptence-page [hasRecords]="hasTermsRecords" [termsConditions]="termsConditionsAccepted"
          [electronicConsent]="electronicConsentAccepted" (isDone)="doneAcceptence()" (logout)="logout()">
        </app-acceptence-page>
      </div>
      <app-empty-results *ngIf="(hasPolicies$ | async) === false && (policiesList$ | async) !== null" header="">
        <empty-results-text>
          <div class="heading-sm empty-results-text">You have no policy on record.</div>
        </empty-results-text>
      </app-empty-results>
    </div>
    <div *ngIf="!isSponsor">
      <div>
        <div id="filter-card">
          <dxo-card data-e2e="filter-group-card">
            <div class="header-container weighted-left">
              <h2 class="card-body-header" data-e2e="SearchGroupsCardHeader">Filter groups</h2>
              <div (click)="clearFilters()" (keydown)="clearFilters()" class="reset">Reset filters</div>
            </div>
            <card-body>
              <form [formGroup]="formGroup">
                <div class="data-containter">
                  <div class="row-input double-even">
                    <dxo-text-input data-e2e="GroupName_input" label="Group name" maxlength="120" class="groupName"
                      formControlName="groupName" (valueChange)="groupName$.next($event)"
                      [value]="searchParameter.groupName">
                    </dxo-text-input>
                    <dxo-text-input data-e2e="GroupNumber_input" label="Group number" maxlength="120"
                      class="groupNumber" formControlName="groupNumber" (valueChange)="groupNumber$.next($event)">
                    </dxo-text-input>
                  </div>
                </div>
              </form>
            </card-body>
          </dxo-card>
        </div>
          <dxo-alert [showBorder]="true" [fullWidth]="true">
            <div class="message-container">
              <div class="button-container">
                <div>
                  <strong>{{AlertText1}}</strong>
                  {{AlertText2}}
                </div>
                <dxo-button-v2 class="alert-button" size="x-small" [href]="AlertButtonLink" [label]="AlertButtonText"></dxo-button-v2>
              </div>
              <div> <strong>{{AlertText3}}</strong> {{AlertText4}} <a class="alert-link" [href]="AlertText5Link">{{AlertText5}}</a></div>
            </div>
          </dxo-alert>
        <div id="list-card">
          <ng-container>
            <dxo-card [bodyHeader]="bodyHeader" class="table-card" data-e2e="all-groups-card">
              <card-body *ngIf="policiesList$ | async as policiesList">
                <div *ngIf="hasPolicies$ | async">
                  <dxo-data-table [headers]="tableHeaders" [items]="policiesList.policies"
                    [showCardViewWhenMobile]="true"
                    [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '' } }]">
                    <ng-template dxoHeaderKey="groupName">
                      <span tabindex="0" class="sort-header" (click)="onClickTableHeader('GroupName')"
                        (keypress)="onClickTableHeader('GroupName')">
                        Group name
                        <dxo-icon [class.ascending]="
                            searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'GroupName'
                          " [color]="searchParameter.sortField === 'GroupName' | getSortIconColor" [fontSize]="20"
                          [right]="true" data-e2e="group-name-sort">
                          sort
                        </dxo-icon>
                      </span>
                    </ng-template>
                    <ng-template dxoHeaderKey="groupNumber">
                      <span tabindex="0" class="sort-header" (click)="onClickTableHeader('GroupNumber')"
                        (keypress)="onClickTableHeader('GroupNumber')">
                        Group number
                        <dxo-icon [class.ascending]="
                            searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'GroupNumber'
                          " [color]="searchParameter.sortField === 'GroupNumber' | getSortIconColor" [fontSize]="20"
                          [right]="true" data-e2e="group-number-sort">
                          sort
                        </dxo-icon>
                      </span>
                    </ng-template>
                    <ng-template dxoKey="groupName" let-item>
                      <span class="row-cell" data-e2e="group-name-cell">
                        <div class="url-item">
                          <a [href]="item.dashboardLink">{{ item.groupName }}</a>
                        </div>
                      </span>
                    </ng-template>
                    <ng-template dxoKey="groupNumber" let-item>
                      <span class="row-cell" data-e2e="group-number-cell">
                        <div class="url-item">
                          <a [href]="item.dashboardLink">{{ item.groupId }}</a>
                        </div>
                      </span>
                    </ng-template>
                  </dxo-data-table>
                  <div class="paginator">
                    <dxo-server-pagination [itemCount]="policiesList.totalResults" [currentPage]="searchParameter.page"
                      [pageSize]="searchParameter.pageSize" (pageChange)="onPageChange($event)"
                      (pageSizeChange)="onPageSizeChange($event)">
                    </dxo-server-pagination>
                  </div>
                </div>
                <dxo-alert *ngIf="(hasPolicies$ | async) === false && (policiesList$ | async) !== null" [fullWidth]="true" status="neutral">{{EmptyResultsText}}</dxo-alert>
              </card-body>
            </dxo-card>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <ng-template #isLoading>
    <div class="top-level-loader">
      <dxo-circular-loader [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
    </div>
  </ng-template>
</div>